import {ChipExpression, ExpertChipExpression, SimpleChipExpression} from "../data/common.data.types";

export abstract class QueryExpressionParserService{

  public abstract isChipExpressionValid(chipExpression: string): boolean;

  public abstract parseChipIntoTokens(chipExpression:string): SimpleChipExpression;
  public abstract getChipKeywords():string[];
  public abstract getChipOperators(): string[];

  public abstract isExpressionValid(expression: string) : boolean;
  // sometimes expression can be fully valid from grammar perspective. But it must be rejected
  // because of some quirks in business logic. This is a channel to communicate between low level/dumb
  // widget and high level/business logic aware component.
  public abstract fitsWithUseCaseConstraints(chips: SimpleChipExpression[]):boolean;
  public abstract parseIntoTokens(expression:string): ExpertChipExpression[];

  public abstract toExpression(chips: SimpleChipExpression[]):string;
  
  public abstract toBreadcrumbExp(chips: SimpleChipExpression[]):string;
  public abstract toAtaBreadcrumbExp(chips: SimpleChipExpression[]):string;
  public abstract setSupportedSearchKeywords(keywords: Array<string>);
  public abstract areChipKeywordValid(keyword: SimpleChipExpression);
}
